export const arrowUp = {
  name: "arrow-up" as const,
  svg: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"><path fill-rule="evenodd" d="M11.364 3.364a.9.9 0 0 1 1.272 0l5.5 5.5a.9.9 0 1 1-1.272 1.272L12.9 6.173V20a.9.9 0 0 1-1.8 0V6.173l-3.964 3.963a.9.9 0 0 1-1.272-1.272l5.5-5.5Z" clip-rule="evenodd"/></svg>`,
  keywords: ["arrow-up"],
  category: "utility" as const,
};
